<template>
  <DicomDevicesList />
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import DicomDevicesList from '@/components/DicomDevicesList.vue'
import { useRoute } from 'vue-router'
import { useSessionStore } from '@/store/session'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'HomeView',
  components: {
    DicomDevicesList
  },
  setup() {
    const route = useRoute()
    const sessionStore = useSessionStore()
    const { t, locale } = useI18n()

    const setLanguage = (lang: string) => {
      locale.value = lang
    }

    onMounted(() => {
      const patientId = (route.query.patientId as string) || null
      const jwt = (route.query.jwt as string) || null
      if (patientId && jwt) {
        sessionStore.setSessionData(patientId, jwt)
      }

      const lang = (route.query.language as string) || 'ro'
      setLanguage(lang)
    })

    return { sessionStore }
  }
})
</script>
